module.exports = __webpack_public_path__ + "img/DomiInsta_Final.1a68fcd5.jpg";